<template>
  <v-list height="22vh">
    <v-list-item-group class="pt-4">
      <template v-if="tabData.ioProperties && tabData.ioProperties.length">
        <v-list-item
          v-for="prop in tabData.ioProperties"
          :key="prop.IoValueFirstOccuranceDate"
        >
          <v-list-item-title class="text-caption font-weight-bold">
            {{ prop.ioName }}:
            <br />
            <p class="text-caption font-weight-regular">
              {{ prop.ioValue }} (od
              {{ convertDate(prop.ioDate) }}
              )
            </p>
          </v-list-item-title>
        </v-list-item>
      </template>

      <template v-if="tabData.hybridIoProperties && tabData.hybridIoProperties.length">
        <v-list-item
          v-for="prop in tabData.hybridIoProperties"
          :key="prop.IoValueFirstOccuranceDate"
        >
          <v-list-item-title class="text-caption font-weight-bold">
            {{ prop.ioName }}:
            <br />
            <p class="text-caption font-weight-regular">
              {{ prop.ioValue }} (od
              {{ convertDate(prop.ioDate) }}
              )
            </p>
          </v-list-item-title>
        </v-list-item>
      </template>

      <v-list-item>
          <v-list-item-title class="text-caption font-weight-bold">Latitude</v-list-item-title>
          <v-list-item-subtitle class="text-caption font-weight-regular">{{ tabData.latitude }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item>
          <v-list-item-title class="text-caption font-weight-bold">Longitude</v-list-item-title>
          <v-list-item-subtitle class="text-caption font-weight-regular">{{ tabData.longitude }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item v-if="hasCoordinates">
          <v-list-item-title class="text-caption font-weight-bold">{{ $t("location") }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption font-weight-regular">
            <a class="maps-link" @click="openInGoogleMaps">{{ $t("openInGoogleMaps") }}</a>
          </v-list-item-subtitle>
      </v-list-item><br/>
      <template v-if="tabData.temperatureSensors && tabData.temperatureSensors.length > 0">
        <v-list-item v-for="(sensor,index) in tabData.temperatureSensors"  v-bind:key="index">
          <v-list-item-title class="text-caption font-weight-bold">{{ $t("temperatureSensor") }} ({{sensor.sensor}}):</v-list-item-title>
          <v-list-item-subtitle class="text-caption font-weight-regular">{{ sensor.value }}℃</v-list-item-subtitle>
      </v-list-item>
      </template>
      <template v-if="tabData.bleSensors && tabData.bleSensors.length > 0">
        <v-list-item v-for="(sensor, index) in tabData.bleSensors"  v-bind:key="index">
          <v-list-item-title class="text-caption font-weight-bold">{{sensor.label}}:</v-list-item-title>
          <v-list-item-subtitle class="text-caption font-weight-regular">{{ sensor.value }}</v-list-item-subtitle>
      </v-list-item>
      </template>

      <template v-if="tabData.accumulatorVoltage">
        <v-list-item>
          <v-list-item-title class="text-caption font-weight-bold">{{ $t("accumulatorVoltage") }}</v-list-item-title>
          <v-list-item-subtitle class="text-caption font-weight-regular">{{ tabData.accumulatorVoltage }} V</v-list-item-subtitle>
      </v-list-item>
      </template>
      
    </v-list-item-group>
  </v-list>
</template>

<script>
import formatDate from '@/utils/formatDateHelper.js'
import translate from '@/utils/genTable/multilanguageHelper.js'
import store from '@/store/store'

export default {
  props: {
    tabData: {
      type: Object,
      required: true
    }
  },
  methods: {
    convertDate(date) {
      return formatDate(date.split('+')[0], 'long', true)
    },
    openInGoogleMaps() {
      const query = `${this.tabData.latitude},${this.tabData.longitude}`
      window.open(
        `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
          query
        )}`,
        '_blank',
        'noopener'
      )
    }
  },
  computed: {
    currentPosition: function() {
      return translate('Current position', 'io')
    },
    hasCoordinates: function() {
      return (
        this.tabData.latitude !== null &&
        this.tabData.latitude !== undefined &&
        this.tabData.latitude !== '' &&
        this.tabData.longitude !== null &&
        this.tabData.longitude !== undefined &&
        this.tabData.longitude !== ''
      )
    }
  }
}
</script>
<style scoped>
.v-list-item {
  min-height: 22px;
}
.maps-link {
  color: var(--v-primary-base);
  cursor: pointer;
  text-decoration: none;
}
.maps-link:hover {
  text-decoration: underline;
}
</style>
